import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import { TTypeOfModalWindow } from '../../../reportsContext/reportsState/reportsContext';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

interface IBtnBlock {
	onDeleteReport: () => void;
	changeTypeOfModalWindow: (value: TTypeOfModalWindow) => void;
	disableDeleteBtn: boolean;
	hasBanOnChanges: boolean;
}

const BtnBlock: React.FC<IBtnBlock> = ({
	onDeleteReport,
	changeTypeOfModalWindow,
	disableDeleteBtn,
	hasBanOnChanges,
}) => {
	const handleCancel = useCallback(() => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	}, []);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button onClick={onDeleteReport} disabled={hasBanOnChanges || disableDeleteBtn} theme="outlined">
					<Text translationNameSpace="form" translationKey="deleteReportButton" asFragment={true} />
				</Button>
				<div className={style.rightButtons}>
					<Button
						className={style.cancelBtn}
						theme="outlined"
						onClick={handleCancel}
						icon={
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#resetIcon`} />
							</svg>
						}>
						<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
					</Button>
					<Button className={style.saveBtn} disabled={hasBanOnChanges} theme="primaryBlue" type="submit">
						<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</Form.Item>
	);
};

export default React.memo(BtnBlock);
